export default __webpack_public_path__ + "171ca938b22700d263b2d94d99cf511d.png";